import logo from '../../assets/logoasf.png';
import 'animate.css';

export const Footer = () => {
    return (
        <footer className='flex flex-col items-center animate__animated animate__fadeInUp'>
            <div className='bg-[#bfc8db] w-full py-8  animate__animated animate__fadeInUp animate__delay-2s'>
                <h6 className='footer-title text-center'>Nous intervenons à</h6>
                <div className="flex flex-wrap items-center justify-center">
                    <span className="text-slate-800 px-2">Montbéliard</span>
                    <span className="text-slate-800 px-2">Audincourt</span>
                    <span className="text-slate-800 px-2">Valentigney</span>
                    <span className="text-slate-800 px-2">Grand-Charmont</span>
                    <span className="text-slate-800 px-2">Seloncourt</span>
                    <span className="text-slate-800 px-2">Bethoncourt</span>
                    <span className="text-slate-800 px-2">Mandeure</span>
                    <span className="text-slate-800 px-2">Sochaux</span>
                    <span className="text-slate-800 px-2">Bavans</span>
                    <span className="text-slate-800 px-2">Bart</span>
                    <span className="text-slate-800 px-2">Voujeaucourt</span>
                    <span className="text-slate-800 px-2">Courcelles-les-Montbéliard</span>
                    <span className="text-slate-800 px-2">Mathay</span>
                    <span className="text-slate-800 px-2">Pont-de-Roide-Vermondans</span>
                    <span className="text-slate-800 px-2">Saint-Maurice-Colombier</span>
                    <span className="text-slate-800 px-2">Isle-Sur-le-Doubs</span>
                    <span className="text-slate-800 px-2">Dampierre-Sur-le-Doubs</span>
                    <span className="text-slate-800 px-2">Mathay</span>
                    <span className="text-slate-800 px-2">Maîche</span>
                    <span className="text-slate-800 px-2">Sancey</span>
                    <span className="text-slate-800 px-2">Pontarlier</span>
                    <span className="text-slate-800 px-2">Saint-Hippolyte</span>
                    <span className="text-slate-800 px-2">Villars-Sous-Dampjoux</span>
                    <span className="text-slate-800 px-2">Dampjoux</span>
                    <span className="text-slate-800 px-2">Noirefontaine</span>
                    <span className="text-slate-800 px-2">Solemont</span>
                    <span className="text-slate-800 px-2">Morteau</span>
                    <span className="text-slate-800 px-2">Territoire de Belfort (90) et alentours</span>
                </div>
            </div>
            <div className='bg-[#e6e6e6] w-full flex flex-col xl:flex-row md:flex-row text-left p-8 justify-around animate__animated animate__fadeInUp animate__delay-2s'>
                <nav>
                    <h6 className='footer-title text-[#2f4b81]'>Terrassement</h6>
                    <a href='/nos-services/10001' className="link link-hover block">Terrassement</a>
                    <a href='/nos-services/10002' className="link link-hover block">Assainissement</a>
                    <p href="/nos-services/10007" className='link link-hover block'>Viabilisation de terrain</p>
                    <p className="block">Nivellement des sols</p>
                    <p href="/nos-services/10005" className='link link-hover block'>Démolition</p>
                    <p href='/nos-services/10004' className="link link-hover block">Évacuation</p>
                </nav>
                <nav>
                    <h6 className='footer-title text-[#2f4b81]'>Aménagement extérieur</h6>
                    <p href="/nos-services/10003" className='link link-hover block'>Aménagement de cour et d'allée</p>
                    <p href="/nos-services/10003" className='link link-hover block'>Aménagement de spa extérieur</p>
                    <p href="/nos-services/10003" className='link link-hover block'>Clôture & portail</p>
                    <p href="/nos-services/10003" className='link link-hover block'>Pose de Terrasse</p>
                    <p href="/nos-services/10003" className='link link-hover block'>Dallage</p>
                </nav>
                <nav>
                    <h6 className='footer-title text-[#2f4b81]'>Paysagisme</h6>
                    <p href="/nos-services/10006" className='link link-hover block'>Défrichage de terrain</p>
                    <p href="/nos-services/10006" className='link link-hover block'>Abattage d'arbre</p>
                    <p href="/nos-services/10006" className='link link-hover block'>Élagage d'arbre</p>
                    <p href="/nos-services/10006" className='link link-hover block'>Dessouchage d'arbre</p>
                    <p href="/nos-services/10006" className='link link-hover block'>Entretien des espaces verts</p>
                    <p href="/nos-services/10006" className='link link-hover block'>Taille de haie et d'arbustes</p>
                </nav>
            </div>
            <div className='w-full flex flex-col justify-around xl:flex-row md:flex-row py-4  animate__animated animate__fadeInUp animate__delay-3s'>
                <div className='flex flex-col text-left mb-3 items-center'>
                    <img
                        src={logo}
                        alt="logo asf-terrassement 25"
                        width={200}
                    />
                    <span className='text-accent font-bold'>Votre partenaire de travaux</span>
                    <span className="text-gray-500 text-sm">Terrassement et aménagement extérieur</span>
                </div>
                <div className='flex flex-col mb-3 items-center'>
                    <span className='text-accent font-bold text-xl mb-3 text-center'>Devis et conseils gratuits au</span>
                    <button className="btn btn-primary rounded-full mb-3 text-2xl">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                            <path fillRule="evenodd" d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z" clipRule="evenodd" />
                        </svg>
                        <a href="tel:+33698009233">06 98 00 92 33</a>
                    </button>
                </div>
                <div className='text-center xl:text-left py-4 items-center'>
                    <nav>
                        <h6 className='footer-title text-center text-secondary'>Plan du site</h6>
                        <a href='/nos-services' className="link link-hover block text-center">Nos services</a>
                        <p className="block text-center">Avis Clients</p>
                        <a href='/contact' className="link link-hover block text-center">Devis gratuit et contact</a>
                        <a href='/nos-realisations' className="link link-hover block text-center">Nos réalisations</a>
                        <a href='/mention-legale' className="link link-hover block text-center">Mentions légales</a>
                    </nav>
                </div>
            </div>
            <div className="m-2 animate__animated animate__bounce animate__delay-2s">
                <p className='text-slate-400 text-center text-sm py-4'>Copyright © {new Date().getFullYear()} - Tous droits réservés à ASF TERRASSEMENT </p>
            </div>
        </footer>
    )
}

export default Footer;